export const LANGUAGES = [
  { code: "en", label: "EN" },
  { code: "es", label: "ES" },
  { code: "fr", label: "FR" },
  { code: "de", label: "DE" },
] as const;

export const CURRENCIES = [
  { code: "USD", label: "USD" },
  { code: "EUR", label: "EUR" },
  { code: "GBP", label: "GBP" },
] as const;

export const FAVORITE_CATALOG: {
  id: string;
  label: string;
  href: string;
  note: string;
}[] = [
  {
    id: "website_server",
    label: "Website Server",
    href: "/web/servers",
    note: "Dedicated AWS small hosting",
  },
  {
    id: "point_of_sale",
    label: "Point of Sale (POS)",
    href: "/pos",
    note: "15 day refundable free trial",
  },
  {
    id: "ecommerce_cart",
    label: "Ecommerce cart",
    href: "/cart",
    note: "15 day refundable free trial",
  },
  {
    id: "train_model",
    label: "Train custom AI",
    href: "/",
    note: "Build a model from your CSV",
  },
];
